'use client';

import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="bg-policeblue-dark text-stonerwhite border-stonerwhite bottom-4 right-4 p-2 font-bold shadow-2xl sm:block fixed hidden cursor-pointer items-center justify-center rounded-full border-2 transition-colors hover:scale-110 active:scale-110"
      >
        <i className="fi fi-rr-arrow-up -mb-1 text-lg align-middle leading-none"></i>
      </button>
    )
  );
};

export default ScrollToTopButton;
